import { ShieldCheck } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import { LogTab } from "../superadmin/Gdpr";

export default function StudioPrivacy() {
  return (
    <div data-testid="studio-privacy-page">
      <PageHeader title="Privacy — Log accessi" subtitle="Chi ha consultato, modificato o esportato i dati dei clienti dello studio." icon={ShieldCheck} testId="studio-privacy-header" />
      <LogTab url="/studio/gdpr/log" />
    </div>
  );
}
